<template>
  <Container type="card-full">
    <div slot="header">
      <el-button @click="save" :loading="btnLoading" v-if="disable">保存</el-button>
      <el-button @click="returnbzj" v-if="disable && !psu.psubzjpayurl">退回保证金</el-button>
      <vxe-button v-for="(btn) in this.$route.params.innerbtn" :key="btn.btncode" icon='el-icon-connection' status="">{{btn.btnname}}</vxe-button>
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div>
      <el-form :model="psu" label-position="right" class="mainfrom">
        <el-form-item label="项目编号" class="from-value">
          {{psu.projectcode}}
        </el-form-item>
        <el-form-item label="项目名称" class="from-value">
         {{psu.projectname}}
        </el-form-item>
        <el-form-item label="供应商" class="from-value">
          {{psu.comfullname}}
        </el-form-item>
        <el-form-item label="保证金" class="from-value">
          {{setThousand(psu.projectbzjamt)}}
        </el-form-item>
        <el-form-item label="保证金支付方式" class="from-value">
          {{Number(psu.psubzjpaytype) === 3 ? '线下支付' : (Number(psu.psubzjpaytype) === 1 ? '支付宝支付':'微信支付')
          }}
        </el-form-item>
        <el-form-item label="退回凭证" v-if="!psu.psubzjreturntradeno">
          <upload-pic-one @changed='setfile' :picUrl='psu.psubzjreturnurl' folderName='web' text="选择图片"></upload-pic-one>
        </el-form-item>
        <el-form-item label="退回单号" v-else>
          {{psu.psubzjreturntradeno}}
        </el-form-item>
        <div v-show='psu.psubzjreturnflg'>
            <el-form-item label="保证金是否退回" class="from-value">
                {{psu.psubzjreturnflg == 0 ? '未退回':'已退回'}}
            </el-form-item>
            <el-form-item label="退回确认人" class="from-value">
                {{psu.psubzjreturnusername}}
            </el-form-item>
            <el-form-item label="保证金退回时间" class="from-value">
                {{psu.psubzjreturntime}}
            </el-form-item>
        </div>
      </el-form>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import uploadPicOne from '../common/uploadPicOne'
  export default {
    name: "psuBzjReturnForm",
    data () {
      return {
        project: this.$route.params.form,
        psuid:this.$route.params.form.psuid,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? false : true,
        btnLoading: false,
        psu:{},
        psuisopenList: [],
        psuflgList: [],
        psubzjreturnuser:[],
        returnpay:{}
      }
    },
    created () {
    },
    activated () {
    },
    mounted(){
      this.init()
      this.getList()
    },
    watch: {},
    filters: {},
    components: {uploadPicOne},
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    methods: {
      setThousand (value) {
        return utils.comdify(value)
      },
      btnClick (code) {
        this.$emit(code)
      },
      async init () {
        this.psu = {}
        this.type = Number(this.$route.params.type)
        this.disable = this.$route.params.type === 3 ? false : true
        this.btnLoading = false
        this.returnpay = {}
        if(this.psu.psubzjreturnflg){
          this.disable = false
        }
      },
      async getList(){
        let data = await request({
            url: '/xmgl/project/searchPay',
            method: "get",
            params:{psuid : this.psuid}
        })

        this.psu = data[0]
      },
      async setfile (path) {
        this.psu.psubzjreturnurl = path.replace(this.uploadAddr, '')
      },
      async getbzjreturnuser(){
        if(Number(this.psu.psubzjreturnflg) != 0){
          this.psubzjreturnuser = await request({
            url: '/xmgl/project/getbzjretuenUser',
            method: "get",
            params: this.psu
          })
        }
      },
      async save () {
        if(this.psu.psubzjreturnuserid){
          this.$message.warning('保证金已退回')
          return
        }
        if(!this.psu.psubzjreturnurl){
          this.$message.warning('请添加凭证')
          this.btnLoading = false
          return
        }
        this.btnLoading = true
        this.psu.psubzjreturnuserid = this.$store.getters.loginUser.userid
        this.psu.psubzjreturnflg = 1
        let data = await request({
          url: '/xmgl/project/savePsuBzjRetuen',
          method: "post",
          data: this.psu
        })
        if (data.issuccess === 1) {
          this.close()
          this.$message.success('保证金退回成功')
        } else {
          this.$message.error('保证金退回失败')
        }
        this.btnLoading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'psuBzjReturnIndex'})
      },
      async returnbzj(){
        if(this.psu.psubzjreturnuserid){
          this.$message.warning('保证金已退回')
          return
        }
        this.$confirm('确定退回?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
            this.btnLoading = true
            this.returnpay.type = Number(this.psu.psubzjpaytype)
            this.returnpay.out_trade_no = this.psu.psubzjpayno  //out_trade_no: '商户内部订单号',
            this.returnpay.out_refund_no = this.psu.psubzjpaytradeno // out_refund_no: '商户内部退款单号',
            if(Number(this.psu.psubzjpaytype) === 1){
              this.returnpay.total_fee = this.psu.projectbzjamt
              this.returnpay.refund_fee = this.psu.projectbzjamt
            }
            else if(Number(this.psu.psubzjpaytype) === 2){
              this.returnpay.total_fee = this.psu.projectbzjamt * 100
              this.returnpay.refund_fee = this.psu.projectbzjamt * 100
            }
            this.returnpay.psuid = this.psu.psuid
            this.returnpay.psubzjreturnflg = 1
            this.returnpay.psubzjreturnuserid = this.$store.getters.loginUser.userid
            let data = await request({
              url: '/common/refund',
              method: "post",
              data: this.returnpay
            })
            this.getList()
            this.$message.success(data['issuccess'])
            this.btnLoading = false
            return
        }).catch(() => {
        });
      },
    }
  }
</script>

<style scoped>

</style>
